/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react'; 
import { useTranslation } from 'react-i18next';   
import FieldButton from '../../../components/Controls/FieldButton/FieldButton.jsx';
import { Column } from 'primereact/column';
import { Row,Col, TabContent, TabPane , Nav, NavItem, NavLink} from 'reactstrap';   
import { config } from '../../../utils/config';
import { callApi,showSweetAlert, tracker } from '../../../utils/utils';  
import FieldDataTable from '../../../components/Controls/FieldDataTable/FieldDataTable.jsx';
import FieldTextArea  from '../../../components/Controls/FieldTextArea.jsx'
import FieldText from '../../../components/Controls/FieldText.jsx' 
import FieldUpload from '../../../components/Controls/FieldUpload/FieldUpload.jsx';
import * as yup from 'yup';
import YupValidator from '../../../utils/YupValidator'; 
import swal from '@sweetalert/with-react';
import SweatAlertCustomIcon from '../../../components/SweatAlert/SweatAlertCustomIcon'
import { Tooltip } from 'primereact/tooltip';

const FasesActividadesAnexo = (props) => { 
  /* ################## useState area start ################## */
  const { t } = useTranslation(['hr', 'common']);
  const [errors, setErrors] = useState({}); 
  const [ClaProyecto, setClaProyecto] = useState(props.ClaProyecto === undefined ? 0 : props.ClaProyecto); 
  const [ClaFase, setClaFase] = useState(props.ClaFase === undefined ? 0 : props.ClaFase); 
  const [ClaActividad, setClaActividad] = useState(props.ClaActividad === undefined ? 0 : props.ClaActividad); 
  const [Comentarios, setComentarios] = useState(null);
  const [Link, setLink] = useState(null);
  const [UploadName, setUploadName] = useState(null);
  const [FieldData, setFieldData] = useState(null); 
  const [datafiles, setdatafiles] = useState([]);
  const [ProyectoRepActTerminadaList, setProyectoRepActTerminadaList] = useState([]);
  const dt = useRef(null); 
  const [TabActiveIndex, setTabActiveIndex] = useState(1);
  const fileRef = useRef(null); 

  useEffect(() => {    
    obtenerInformacionFasesProyecto();
    if(props.IsUpload !== undefined && !props.IsUpload){
      setTabActiveIndex(2); 
    }
  }, []); 

  useEffect(() => {
  }, [props.Filters]); 

  
  const obtenerInformacionFasesProyecto = () => { 
    const GetSummaryScorecardUser = `${config.UrlApiProject}ScoreCard/GetProyectoRepActTerminadaList`;  
    const paramsToService = { 
      ClaProyecto,
      ClaFase,
      ClaActividad
    };   
    callApi(GetSummaryScorecardUser, 'POST', paramsToService, (response) => { 
      const {AnexosRefenciados} = response.data;
      if (AnexosRefenciados !== undefined)
      {  
        setProyectoRepActTerminadaList(AnexosRefenciados)
      }
    });
  }
 
  const onChangeComentarios = (e) => { 
    const newErrors = { ...errors } 
    delete newErrors.Comentarios;   
    setErrors(newErrors) 
    setComentarios(e.target.value)
  } 

  const onChangeLink = (e) => { 
    const newErrors = { ...errors } 
    delete newErrors.Link;   
    setErrors(newErrors) 
    setLink(e.target.value)
  } 
 
const save = async () => {
   
  if(datafiles.length===0){
    showSweetAlert(t('common:Warning'), t('scoreCard:AttachFile'), 'warning');
    return;
  }
  const urlWebServiceSave = `${config.UrlApiProject}ScoreCard/SaveProyectoRepActTerminada`;
  const paramsService = {
    ClaProyecto,
    ClaFase,
    ClaActividad,
    Comentarios,
    Link,
    FileData:datafiles[0].FileData,
    NomArchivo:datafiles[0].FileName,
    Extension:datafiles[0].FileExtension
  }; 
  callApi(urlWebServiceSave, 'POST', paramsService, (response) => { 
    setComentarios(null);
    setUploadName(null);
    setFieldData(null);
    setLink(null);
    setdatafiles([]); 
    showSweetAlert('success', t('common:SuccessOperation'), 'success');
    obtenerInformacionFasesProyecto();
    setTabActiveIndex(2); 
    tracker.trackEvent({
      type: 'FasesActividadesAnexo', /* component name */
      action: 'ADD_ATTACHMENT_ACTIVITY'
    })

 })
};

 const switchTab = tab => {
  if(TabActiveIndex !== tab){
    setTabActiveIndex(tab);
  }
}

 const confirmationMessageHTML = (
   <div>
     <SweatAlertCustomIcon title={t('common:SubmitConfirmation')} letter={t('common:QuestionMark')}></SweatAlertCustomIcon> 
     <div>{t('scoreCard:SubmitRemoveDocument')}. </div> 
   </div>  
 )

 const downloadFile = (rowData) => { 
    const GetFileData = `${config.UrlApiProject}ScoreCard/GetProyectoRepActTerminadaId`;  
    const paramsToService = { 
      IdProyectoRepActTerminada:rowData.IdArchivo
    };   
    callApi(GetFileData, 'POST', paramsToService, (response) => {
      const AnexoDetalle = response.data.AnexoDetalle[0];
      if(AnexoDetalle!==undefined){
        const linkSource = `data:application/${rowData.TipoExtension};base64,${AnexoDetalle.FileData}`;
        const downloadLink = document.createElement("a");
        const fileName = `${rowData.NombreArchivo}`;
        downloadLink.href = linkSource;
        downloadLink.download = `${fileName  }.${  rowData.TipoExtension}`;
        downloadLink.click();
      }
    });
 }
 
const onConfirmRemoveSubmit = (nIdProyectoRepActTerminada) => {  
  swal({ 
    buttons: {
      cancelar: {
        text: "Cancel",
        value: "cancel",
        className: "rounded-button danger"
      },
      continuar: {
        text: "Continue",
        value: "continue",
        className: "rounded-button light-green"
      }
    },
    content: confirmationMessageHTML
  }).then((value) => {
    switch (value) { 
      case "continue":
        // run function
        onSubmit(nIdProyectoRepActTerminada);
        break; 
      default:
        break;
    }
  }); 
}

const onSubmit = async (nIdProyectoRepActTerminada) => { 
  const paramsService = {
    IdProyectoRepActTerminada:nIdProyectoRepActTerminada
 };   
 const SubmitBajaProyectoRep = `${config.UrlApiProject}ScoreCard/BajaProyectoRepActTerminada`;
 callApi(SubmitBajaProyectoRep, 'POST', paramsService, (response) => { 
  obtenerInformacionFasesProyecto(); 
 });   
} 

const NomArchivoTemplate = (rowData) => {
  return (
    <>
      { `${rowData.NombreArchivo}.${rowData.TipoExtension}` } 
    </>
  )
}
 
const AnexoInfo = (rowData) => {
    return (
      <>   
        <Col className="text-right">
          <Tooltip target=".p-button-info" mouseTrack mouseTrackTop={10} />
          <FieldButton
            type="button" 
            onClick={() => downloadFile(rowData)}
            data-pr-position="top" 
            data-pr-tooltip={t('scoreCard:Download')}
            icon="pi pi-arrow-circle-down"
            className="p-button-rounded p-button-info p-button-outlined"
          /> 
                    &nbsp;
          { 
          props.IsReadyOnly !== undefined && props.IsReadyOnly ?
          (
            <></>
          )
          :
          (
            <>
              <Tooltip target=".p-button-danger" mouseTrack mouseTrackTop={10} />
              <FieldButton
                type="button" 
                onClick={() => onConfirmRemoveSubmit(rowData.IdArchivo)}
                data-pr-position="top" 
                data-pr-tooltip={t('scoreCard:Remove')}
                icon="pi pi-trash"
                className="p-button-rounded p-button-danger p-button-outlined"
              />
            </>
)
        } 
        </Col>
      </>
    );
  }
  
    return (
      <>     
        <div className="p-tabview p-component pb-3">
          <Nav className="p-tabview-nav">
            <NavItem hidden={props.IsUpload !== undefined && !props.IsUpload} className={TabActiveIndex === 1 ? "p-tabview-selected p-highlight p-unselectable-text nav-item flex-sm-fill" : "p-unselectable-text nav-item flex-sm-fill"}>
              <NavLink className="p-tabview-nav-link" onClick={() => { switchTab(1); }}>
                {t('scoreCard:Upload')}
              </NavLink>
            </NavItem>
            <NavItem hidden={props.IsUpload !== undefined && !props.IsUpload} className={TabActiveIndex === 2 ? "p-tabview-selected p-highlight p-unselectable-text nav-item flex-sm-fill" : "p-unselectable-text nav-item flex-sm-fill"}>
              <NavLink className="p-tabview-nav-link" onClick={() => { switchTab(2); }}>
                {t('scoreCard:UploadedDocuments')}
              </NavLink>
            </NavItem>
          </Nav> 
        </div>
        <TabContent className="p-tabview-panels" activeTab={TabActiveIndex}>
          <TabPane tabId={1} hidden={props.IsUpload !== undefined && !props.IsUpload}> 
            <Row>
              <Col lg={1} md={1} sm={12} xs={12}> 
                <span className="bold">{t('scoreCard:File')}</span> 
              </Col>
              <Col>
                <FieldUpload files={datafiles} onChange={(files) => setdatafiles(files)}></FieldUpload>
              </Col>
            </Row>
            <Row className="pt-2">
              <Col lg={1} md={1} sm={12} xs={12}> 
                <span className="bold">{t('scoreCard:Comments')}</span>
              </Col>
              <Col>
                <div className="p-fluid"> 
                  <FieldTextArea 
                    name="Comentarios"
                    rows={2}
                    value={Comentarios} 
                    onChange={onChangeComentarios}
                    errors={errors} 
                    maxLength={1000}
                  />
                </div>
              </Col>
            </Row>
            <Row className="pt-2 pb-5">
              <Col lg={1} md={1} sm={12} xs={12}> 
                <span className="bold">{t('scoreCard:URL')}</span> 
              </Col>
              <Col>
                <div className="p-fluid"> 
                  <FieldText   
                    name="Link"
                    value={Link} 
                    onChange={onChangeLink}
                    maxLength={100}
                    errors={errors}
                  />
                </div>
              </Col>
            </Row> 
            <Row>
              <Col className="text-right">
                <FieldButton
                  type="button" 
                  onClick={save}
                  label={t('common:Save')}
                  className="p-button-success no-border p-mr-2 rounded-button"
                  style={{ marginRight: '.25em' }}
                /> 
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId={2}>
            <Row className="pt-3">
              <Col>
                <div style={{minHeight:"300px"}}>
                  <FieldDataTable 
                    value={ProyectoRepActTerminadaList} 
                    header={t('scoreCard:Documents')}
                    scrollable 
                    scrollHeight="250px"
                    className="p-datatable-striped"
                  > 
                    <Column field="NomUsuarioInsArchivo" columnKey="NomUsuarioInsArchivo" header={t('scoreCard:User')} headerStyle={{ width: '120px' }}></Column> 
                    <Column field="NomArchivo" body={NomArchivoTemplate} columnKey="NomArchivo" header={t('scoreCard:File')} headerStyle={{ width: '240px' }}></Column> 
                    <Column field="Comentarios" columnKey="Comentarios" header={t('scoreCard:Comments')} headerStyle={{ width: '180px' }}></Column> 
                    <Column field="Link" columnKey="Link" header={t('scoreCard:Link')} headerStyle={{ width: '90px' }}></Column> 
                    <Column body={AnexoInfo} headerStyle={{ width: '90px' }}></Column> 
             
                  </FieldDataTable> 
                </div>
              </Col>
            </Row> 
          </TabPane>
        </TabContent>
      </> 
        ); 
};
export default FasesActividadesAnexo;